import React, { useState, useEffect, useRef } from "react";
import { makeStyles, useTheme } from "@mui/styles";
import Grid from "@mui/material/Grid";
import { CKEditor } from 'ckeditor4-react';
import Helper from "../../common/Helper";
import { darkenColor } from "../../utils/appHelper";

const useStyles = makeStyles((theme) => ({
    grid: {
        padding: theme.spacing(1),
        alignSelf: "center",
    },
    errorMessage: { color: 'red', paddingLeft: '2px' }
}));


const HTMLEditor = (props) => {
    const classes = useStyles();
    const [value, setValue] = useState(props.data);
    const theme = useTheme();
    const editorRef = useRef(null);

    useEffect(() => {
        setValue(props.data);
        // Push updated data into the editor instance when props.data changes asynchronously
        if (editorRef.current && props.data !== undefined) {
            const currentData = editorRef.current.getData();
            if (currentData !== props.data) {
                editorRef.current.setData(props.data);
            }
        }
    }, [props.data]);

    const onChange = (e) => {
        setValue(e.editor.getData());
        e.target = { name: props.name, value: e.editor.getData() };
        props.onChange(e);
    }
    return (
        <Grid container>
            <Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', fontStyle: 'italic', color: 'gray', fontSize: '11px' }}>{Helper.RemoveTags(value).length} chars</div>
                <CKEditor
                    key={theme.palette.mode} // forces re-mount when light/dark mode changes
                    config={{
                        extraPlugins: 'autogrow', autoGrow_minHeight: 50,
                        contentsCss: `body { background-color: ${theme.palette.background.paper}; color: ${theme.palette.text.primary}; }`,
                        on: {
                            instanceReady: function () {
                                editorRef.current = this;
                                // Apply inline CSS to the toolbar once the editor is ready
                                const toolbar = this.container.$.querySelector('.cke_top');
                                if (toolbar) {
                                    toolbar.style.backgroundColor = darkenColor(theme.palette.background.default, 5);
                                    toolbar.style.color = theme.palette.text.primary;
                                }
                                const footer = this.container.$.querySelector('.cke_bottom');
                                if (footer) {
                                    footer.style.backgroundColor = darkenColor(theme.palette.background.default, 5);
                                    footer.style.color = theme.palette.text.primary;
                                }
                                // Set initial data after editor is ready in case props.data arrived before instanceReady
                                if (props.data) {
                                    this.setData(props.data);
                                }
                            }
                        }
                    }}
                    data={value}
                    onChange={onChange}
                />
                {props.error ? <p className={classes.errorMessage}>
                    {props.error}</p> : null}
            </Grid>
        </Grid>
    );
};

export default HTMLEditor;